import { MediaType, CXoneDispositionDetails } from '@nice-devone/common-sdk';
import { logger } from '../../../utils/logger';
import { getDispositionService } from '../call-control';

/**
 * Get dispositions for skill
 */
export async function getDispositions(skillId: string, contactId?: string): Promise<unknown[]> {
  logger.debug('[CXone SDK] Getting dispositions for skill:', skillId);
  const service = getDispositionService();
  return service.getDispositions(skillId, MediaType.VOICE, contactId);
}

/**
 * Save disposition for call
 */
export async function saveDisposition(
  contactId: string,
  dispositionId: string,
  notes?: string
): Promise<void> {
  logger.debug('[CXone SDK] Saving disposition:', dispositionId);
  const service = getDispositionService();
  const dispositionDetails = new CXoneDispositionDetails();
  dispositionDetails.primaryDispositionId = parseInt(dispositionId, 10);
  dispositionDetails.primaryDispositionNotes = notes || '';
  await service.saveDisposition(contactId, dispositionDetails);
}
